import { INIT_CONSENT_LIST, GET_CONSENT_SUCCESS, SET_CURRENT_PAGE, SET_CURRENT_PAGE_READ, TOGGLE_CONSENT } from './consentTypes';

const initialState = {
  pageIdx: 0,
  pageCount: 1,
  pages: [],
};

const consentReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_CONSENT_LIST: {
      return { ...state, pageCount: action.pageCount, pageIdx: action.pageIdx, pages: action.pages };
    }
    case SET_CURRENT_PAGE: {
      return { ...state, pageIdx: action.pageIdx };
    }
    case SET_CURRENT_PAGE_READ: {
      return { ...state, pageIdx: action.pageIdx, pages: action.pages };
    }
    case GET_CONSENT_SUCCESS: {
      return { ...state, pageIdx: action.pageIdx, pages: action.pages };
    }
    case TOGGLE_CONSENT: {
      return { ...state, pages: action.pages };
    }
    default:
      return state;
  }
};

export { initialState };
export default consentReducer;
